import axios from 'axios';
import config from './config';

const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

const preloadImages = (imageUrls, dispatch) => {
    imageUrls.forEach((url) => {
        const img = new Image();
        img.onload = () => {
            dispatch({ type: 'ADD_TO_CACHE', payload: {url, img}});
        };
        img.src = url;
    });
};

export const loginCall = async (userCredentials, dispatch) => {
  dispatch({type: "SET_LOADING", payload: true});  
  dispatch({type: "LOGIN_START"});
    try {
        const res = await axios.post(`${config.apiUrl}/api/auth/login`, userCredentials, {
          withCredentials: true
        });
        // extract the token from the response
        const { token, user, wishlistItems } = res.data;
        localStorage.setItem("token", token);
        const wishlistImageUrls = wishlistItems.map((item) => item.imageUrl);
        const shareIcons = [`${cloudfrontUrl}/static/instagram-brands-solid.svg`, `${cloudfrontUrl}/static/message-solid.svg`, `${cloudfrontUrl}/static/x-twitter-brands-solid.svg`];
        const shareStepGifs = [`${cloudfrontUrl}/static/ig-step-3.jpeg`, `${cloudfrontUrl}/static/ig-step-4.MP4`, `${cloudfrontUrl}/static/messages-2-final.webp`, `${cloudfrontUrl}/static/x-2-final.webp`];
        const imageUrls = [...wishlistImageUrls, ...shareIcons, ...shareStepGifs];

        // cache images into 'ADD_TO_CACHE' context
        preloadImages(imageUrls, dispatch);
        dispatch({type: "LOGIN_SUCCESS", payload: user});
        dispatch({type: "SET_LOADING", payload: false});

      } catch (err) {
        let errorMessage;
        // Check if the error response exists and has a specific status code
        if (err.response) {
          if (err.response.status === 400) {
            errorMessage = 'Incorrect login information';
          } else if (err.response.status === 500) {
            errorMessage = 'Server error. Please try again later.';
          }
          // Add more conditions as needed based on your API's error responses
        } else if (err.request) {
          // Network error or no response received
          errorMessage = 'Network error. Please check your connection.';
        }
        dispatch({ type: "LOGIN_FAILURE", payload: errorMessage });
        dispatch({type: "SET_LOADING", payload: false});
      }
};

// why do we need getUser and loginCall?
// this /auth/me route only checks for a valid token
export const getUser = async (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) {
    // setting popup messages
    dispatch({ type: "LOGIN_FAILURE", payload: 'Log in or register to gain full access to all features' });
    return;
  }
  try {
    const res = await axios.get(`${config.apiUrl}/api/auth/me`, {
      headers: {
          "x-auth-token": token,
        },
    });
    dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
    return res.data;
  } catch (error) {
    // dispatch({ type: "LOGIN_FAILURE", payload: 'Log in to gain full access.' });
  }
};

export const getBalance = async (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return Promise.resolve(0); // return a promise that resolves to 0
  }
  try {
    const res = await axios.get(`${config.apiUrl}/api/billing-settings-balance`, {
      headers: {
          "x-auth-token": token,
        },
    });
    dispatch({ type: "UPDATE_BALANCE", payload: res.data.balance });
  } catch (error) {
    alert('An unexpected error occurred when fetch your balance. Please try again later.')
  }
};